import script from "./AccountPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountPage.vue?vue&type=script&setup=true&lang=js"

import "./AccountPage.vue?vue&type=style&index=0&id=29534e64&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29534e64"]])

export default __exports__